"use client";

export { ViewportScanner } from "@/components/Scanner/ViewportScanner";
